export default "__VITE_ASSET__ocF6h4IY__"